<template>
    <div>
        <page-title heading="Farmasi" :breadcrumb="[
            {
                label: 'Dashboard',
                link: '/'
            },
            {
                label: 'Farmasi',
                active: true
            }
        ]" />
        <div class="container-fluid">
            <div class="card card-box mb-3 ninja-shadow mt-3">
                <div class="card-body">
                    <div class="col-md-12 no-padding">
                        <DataTableWrapper :perPage="perPage" :fromPage="fromPage" :toPage="toPage"
                            :totalEntries="totalEntries" :currentPage="currentPage" :callbackFunc="fetchListFarmasi"
                            @valueChanged="handleValueChanged">

                            <b-table thead-tr-class="izd-datatable text-center" :items="farmasiList" :fields="fieldList"
                                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :no-local-sorting="true">
                                <template v-slot:head()="data">
                                    {{ data.label }}
                                    <b-input size="sm" class="mt-2 w-95" v-if="data.field.searchable"
                                        @input="searchValueChanged($event, data.field.key)" />
                                </template>
                                <template v-slot:head(status)="data">
                                    {{ data.label }}
                                    <select class="form-control select-status" @input="
                                        searchValueChanged($event.target.value, data.field.key)
                                        ">
                                        <option value="">Semua</option>
                                        <option value="BELUM LUNAS">Belum Lunas</option>
                                        <option value="LUNAS">Lunas</option>
                                    </select>
                                </template>
                                <template v-slot:head(status_bhp)="data">
                                    {{ data.label }}
                                    <select class="form-control select-status" @input="
                                        searchValueChanged($event.target.value, data.field.key)
                                        ">
                                        <option value="">Semua</option>
                                        <option value="0">Menunggu</option>
                                        <option value="1">Disiapkan</option>
                                        <option value="2">Obat Siap</option>
                                        <option value="3">Diserahkan</option>
                                    </select>
                                </template>

                                <template v-slot:cell(status)="data">
                                    <span :class="{ 'text-danger': !isPaidOff(data.item.status) }">
                                        {{ data.item.status }}
                                    </span>
                                </template>
                                <template v-slot:cell(status_bhp)="data">
                                    <span>{{ getStatusText(data.item.status_bhp) }}</span>
                                    <!-- <span>
                                        
                                        {{  data.item.status_bhp=== '0' ? 'Menunggu' : data.item.status_bhp === '1' ?
                                            'Disiapkan'
                                            : data.item.status_bhp === '2' ? 'Obat Siap' : 'Diserahkan' }}
                                           
                                    </span> -->
                                </template>
                                <template v-slot:cell(actions)="data">
                                    <span>
                                        <b-button @click.prevent="clickDetailFarmasi(data.item.id)" variant="primary"
                                            size="sm" class="text-uppercase align-self-end">Lihat
                                            Detail</b-button>
                                    </span>
                                </template>
                                <template v-slot:cell(updated)="data">
                                    <label style="font-size:12px;">
                                        {{ data.item.updated.at }} <br>
                                        by <b>{{ data.item.updated.by }}</b>
                                    </label>
                                </template>
                            </b-table>
                        </DataTableWrapper>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import startCase from "lodash/startCase";
import debounce from "lodash/debounce";
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
moment.locale("id");
export default {
    components: {
        DataTableWrapper: () => import("../../components/DataTableWrapper")
    },
    data() {
        return {
            sortBy: "",
            sortDesc: false,
            currentPage: 1,
            rows: 0,
            fromPage: 0,
            toPage: 0,
            perPage: 10,
            farmasiList: [],
            namaPasien: "",
            isOperator: "",
            noRekamMedis: "",
            tanggalLahir: "",
            checkPaketData: null,
            searchValue: [],
            totalEntries: 0,
        }
    },
    computed: {
        ...mapGetters({
            isDoctor: "doctorRole",
            getRolesName: "getRolesName",
            getKlinikId: "getKlinikId"
        }),
        fieldList() {
            const {
                generateFieldList: g,
                setSearchableAndSortableFieldList: s
            } = this;
            const r = val => Boolean(/(no|actions|updated)\b/gi.test(val) ? !1 : 1);
            return (
                [
                    {
                        key: "no"
                    },
                    {
                        key: "nama_pasien",
                        label: "nama pasien"
                    },
                    {
                        key: "nama_dokter",
                        label: "nama dokter",
                        tdClass: "text-center"
                    },
                    {
                        key: "status",
                        label: "status pembayaran",
                        tdClass: "text-center"
                    },
                    {
                        key: "status_bhp",
                        label: "status obat & BHP",
                        tdClass: "text-center"
                    },
                    {
                        key: "actions"
                    },
                    { key: "updated", label: "last modified" },
                ]
                |> (v => s({ field: v, customFunc: r }))
                |> (z => g({ field: z }))
            );
        }
    },
    watch: {
        currentPage() {
            this.fetchListFarmasi();
        },
        perPage() {
            this.fetchListFarmasi();
        },
        sortBy() {
            this.fetchListFarmasi();
        },
        sortDesc() {
            this.fetchListFarmasi();
        },
        searchValue: {
            handler: "fetchListFarmasi",
            deep: true
        },
    },
    methods: {
        handleValueChanged({ perPage, currentPage }) {
            perPage && (perPage |> (_ => (this.perPage = _)));
            currentPage && (currentPage |> (_ => (this.currentPage = _)));
        },
        searchValueChanged: debounce(function (val, key) {
            const { searchValue } = this;
            const z = searchValue.filter(item => item.key !== key);
            this.searchValue = [
                ...z,
                {
                    key,
                    value: val
                }
            ];
        }, 500),
        determineParameter() {
            const { searchValue, sortBy, sortDesc } = this;
            let v = "";
            searchValue.map(item => {
                const x = (item.key === "nama" && "nama_pasien") || item.key;
                v += `&${x}=${item.value}`;
            });

            if (sortBy) {
                v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
            }

            return v;
        },
        
        async fetchListFarmasi() {
            try {
                const tanggalLahir =
                    this.tanggalLahir && moment(this.tanggalLahir).format("YYYY-MM-DD");
                const res = await axios.get(
                    `${this.url_api}/farmasi?klinik_id=${this.getKlinikId}&limit=${this.perPage
                    }&page=${this.currentPage}${this.determineParameter()}`
                );

                const { status, data } = res.data;
                if (status) {
                    const {
                        data: listFarmasi,
                        total: totalEntries,
                        to: toPage,
                        from: fromPage
                    } = data;
                    this.totalEntries = totalEntries;
                    this.toPage = toPage;
                    this.fromPage = fromPage;
                    this.farmasiList = [
                        ...listFarmasi.map((item, index) => {
                            return {
                                ...item,
                                no: (this.currentPage - 1) * this.perPage + index + 1,
                                updated: {
                                    at: moment(item.updated.at).format("MMM DD, YYYY @ HH:mm"),
                                    by: item.updated.by || 'anonim'
                                }
                            };
                        })
                    ];
                    this.rows = data.total;
                    return this;
                }
            } catch (err) {
                // console.log(err);
            }
        },
        clickDetailFarmasi(id) {
            this.$router.push({
                name: "farmasi-detail",
                params: {
                    id: id
                }
            });
        },
        isPaidOff(status) {
            return status.toLowerCase() == "lunas";
        },
        getStatusText(status_bhp) {
            switch (parseInt(status_bhp)) {
                case 0:
                    return 'Menunggu';
                case 1:
                    return 'Disiapkan';
                case 2:
                    return 'Obat Siap';
                case 3:
                    return 'Diserahkan';
                default:
                    return '-';
            }
        },
    },

}
</script>

<style lang="css" scoped>
.select-status {
    margin-top: 7px;
    height: 30px;
    font-size: 11pt;
    padding: 0;
}

.select-status option {
    font-size: 9pt;
}
</style>